export default __webpack_public_path__ + "static/media/illustration-elements_illustration01.5dd4b710.svg";